import { createContext, useContext, useState } from "react";

const CargoViewContext = createContext();

export const CargosViewSwitcherProvider = ({ children }) => {
	const [currentView, setCurrentView] = useState(1);
	const handleViewChange = (target) => {
		if (target === "moje") {
			setCurrentView(1);
			return;
		}

		if (target === "organizacja") {
			setCurrentView(2);
			return;
		}

		const switchTarget = currentView === 1 ? 2 : 1;

		setCurrentView(switchTarget);
		return;
	};

	const value = {
		currentView,
		handleViewChange,
	};

	return (
		<CargoViewContext.Provider value={value}>
			{children}
		</CargoViewContext.Provider>
	);
};

export const useCargosViewSwitcher = () => useContext(CargoViewContext);
